import { render, staticRenderFns } from "./SaoHeiXiShan.vue?vue&type=template&id=597badfd"
import script from "./SaoHeiXiShan.vue?vue&type=script&lang=js"
export * from "./SaoHeiXiShan.vue?vue&type=script&lang=js"
import style0 from "./SaoHeiXiShan.vue?vue&type=style&index=0&id=597badfd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports